import type { BillingInterval } from './types';

/**
 * The server's describe_discount() (apps/nexus/nexus/routes/billing.rs) is now
 * interval-aware and phrases annual campaigns in billing periods itself, so
 * this is a compatibility shim for responses from an API old enough to still
 * send the month-only wording. It rewrites only that one phrase on an annual
 * interval and passes everything else — including the server's corrected copy
 * — through untouched; the client has no `duration` field to derive a fully
 * correct sentence from, so it can only patch the wording it recognises.
 */
export function correctedDiscountDescription(
  description: string | null,
  interval: BillingInterval,
): string | null {
  if (description === null || interval !== 'year') return description;
  if (description === 'First month free') return 'Free for the first billing period';
  if (description.endsWith('for the first month')) {
    return `${description.slice(0, -'for the first month'.length)}for the first billing period`;
  }
  return description;
}
